import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import { BASE_URL } from '../Config/Base';

const FoundSectionWhoweareMain = () =>{

  useEffect(()=>{

    GetAddressOM();
    GetAddressOF();

  })

  
  function GetAddressOM(){

    fetch(`${BASE_URL}/Foundation/GetOMTable`, {
  
      method: 'GET',
  
      headers: {
  
        "Content-type": "application/json",
        "Accept": "application/json",
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
  
      .then(data => {
        console.log("Data", data);
        //setAddress(data);
        // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        localStorage.setItem("paginationDataOM", JSON.stringify(data));
          }
      );
  
    } 

    function GetAddressOF(){

      fetch(`${BASE_URL}/Foundation/GetOFTable`, {
    
        method: 'GET',
    
        headers: {
    
          "Content-type": "application/json",
          "Accept": "application/json",
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    
        },
    
        //body:JSON.stringify(data)
    
      }).then(response => response.json())
    
        .then(data => {
          console.log("Data", data);
          //setAddress(data);
          // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
          localStorage.setItem("paginationDataOF", JSON.stringify(data));    
        }
        );
    
      }  

  return (

    <div className='foundation-addmain mainimage'>

    <div className="foundation-addgrid-layout"> 
    <div className="foundation-addmain-top">
    <div className='foundation-addmain-back'>
    <Link to='/FoundSection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Who we are</span>
    </div>
    </div>

    <div className='section-responsive'>
    <div className='foundation-section' id="section-menu" >

    <ul>
       
    <li><Link to="/FoundSectionOM"><button className='foundation-sec-button' type='submit'>Our Mission &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>
    
    <li><Link to="/FoundSectionOF"><button className='foundation-sec-button' type='submit'>Our Founders &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>
    
    
    
    
    </ul>
    </div>
    </div>
    
    </div>
  )
}

export default FoundSectionWhoweareMain
